// extracted by mini-css-extract-plugin
module.exports = {"content":"ComprovanteDePagamento_content__3M5V3","th_tr_Responsive":"ComprovanteDePagamento_th_tr_Responsive__2xgAC"};